import React from 'react';


import Col from 'react-bootstrap/Col';
import ListView from '../shared/lists/ListView';
import NameFranchiseEditor from '../shared/editors/NameFranchiseEditor';
import NameFranchiseItem from '../shared/editors/NameFranchiseItem';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import useFilter from '../../utilities/useFilter';
import permissionsProvider from '../../utilities/permissionsProvider';

const LeadSourceList = (props) => {
    const getUrl = '/api/lookups/list';
    const editUrl = '/api/lookups/LeadSource/edit/';
    const postUrl = '/api/lookups/LeadSource/edit';
    const deleteUrl = '/api/lookups/LeadSource/delete';

    const { items, setData, submitFilter, pageInfo, canCreate, isLoaded } = useFilter(getUrl, { lookupType: 'LeadSource' }, true);

    const canAdd = canCreate ? items.filter(i => i.id === 0).length === 0 : false;

    function addNew() {
        const currentData = [ ...items ];
        if (canAdd) {
            currentData.push({
                id: 0
        });
            setData(currentData);
        }
    }

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <SortableTh content="Name" sortName="Name" sort={pageInfo} />
                <SortableTh className="two-button-cell" />
            </tr>
        </thead>
    );

    const leadSources = items.map((item) => item.id !== 0
        ? (
            <NameFranchiseItem
                deleteUrl={deleteUrl}
                editItem={() => props.setEditItem(item)}
                viewItem={() => props.setEditItem(item)}
                fetchData={submitFilter}
                hideFranchise={true}
                item={item}
                key={item.id}
            />
        ) : (
            <NameFranchiseEditor
                cancelEdit={submitFilter}
                fetchData={submitFilter}
                getUrl={editUrl + item.id}
                hideFranchise={true}
                item={item}
                key={item.id}
                postUrl={postUrl}
            />
        )
    );

    return (
        <Row>
            <Col>
                <ListView
                    addItem={addNew}
                    canAdd={canAdd && canCreate}
                    itemName="Lead Source"
                    items={leadSources}
                    tableHead={tableHead}
                    isLoaded={isLoaded}
                    pageInfo={pageInfo}
                />
            </Col>
        </Row>
    );
}

export default LeadSourceList;